import { differenceInMonths } from 'date-fns';

import { normalizeDateInput } from './domain';

// Conversion helpers for explicit boundary cases:
// - reinterpreting values for GMT display
// - serializing timezone-aware Dates into local-naive datetime strings
export function daysToMilliseconds(days: number) {
  return 1000 * 60 * 60 * 24 * days;
}

function formatAbbreviatedDateDistancePart(amount: number, index: number) {
  if (amount === 0) {
    return null;
  }

  return `${amount} ${index === 0 ? 'yr' : 'mo'}${amount > 1 ? 's' : ''}`;
}

export function formatDurationYearsAndMonthsAbbr({
  start,
  end,
}: {
  start: string | number | Date;
  end: string | number | Date;
}) {
  const distance = differenceInMonths(
    normalizeDateInput(start),
    normalizeDateInput(end),
  );

  if (!distance) {
    return null;
  }

  const years = Math.floor(distance / 12);
  const months = distance - years * 12;

  return [years, months]
    .map((amount, index) => formatAbbreviatedDateDistancePart(amount, index))
    .filter((amount) => amount)
    .join(', ');
}

function adjustDateByTimezoneOffset(date: Date, direction: 1 | -1) {
  return new Date(
    date.getTime() + date.getTimezoneOffset() * 60000 * direction,
  );
}

export function reinterpretDateForGmtDisplay(date: string | Date) {
  return adjustDateByTimezoneOffset(new Date(date), 1);
}

export function serializeLocalNaiveDateTime(date: Date): string {
  const convertedDate = adjustDateByTimezoneOffset(date, -1);
  return convertedDate.toISOString().replace('Z', '');
}
